module.exports = __webpack_public_path__ + "static/media/4.073fbd81.jpg";